export const ORGANIZATION_TYPES = {
  TENANT: "tenant",
  CLUB: "club",
  UNIVERSITY: "university",
  SCHOOL: "school",
  YOUTH: "youth",
  OTHER: "other",
} as const;

export const ORGANIZATION_LIVE_EVENTS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;
